import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {MatSelectChange} from '@angular/material/select';
import {TranslateService} from '@ngx-translate/core';
import {GridComponent} from '@syncfusion/ej2-angular-grids';
import {TreeViewComponent} from '@syncfusion/ej2-angular-navigations';
import {LocalStorageService} from 'src/app/local-storage.service';
import {BenutzerModels} from 'src/app/models/benutzer-models';
import {TimeSheetModels} from 'src/app/models/timesheet-models';
import {MainDataService} from 'src/app/services/main-data.service';
import {MessageBoxService} from 'src/app/services/message-box.service';
import {ObjektDataService} from 'src/app/services/objekt-data.service';
import {SwissSettingsService} from 'src/app/services/swiss-settings.service';
import {AppEinstellungenBaseComponent} from '../app-einstellung-base-component';
import {Router} from '@angular/router';
import {SpeedDialItemEventArgs} from '@syncfusion/ej2-angular-buttons';
import {HelperService} from 'src/app/services/helper.service';
import {UserAuthenticationService} from '../../../services/user-authentication.service';
import {Device, DeviceDetectionService} from '../../../services/device-detection-service';
import {SwissInternModels} from '../../../models/swissintern-models';
import StartSite = SwissInternModels.StartSite;


@Component({
    selector: 'app-app-einstellungen-mobile',
    templateUrl: './app-einstellungen-mobile.component.html',
    styleUrls: ['./app-einstellungen-mobile.component.scss'],
})
export class AppEinstellungenMobileComponent extends AppEinstellungenBaseComponent implements OnInit {
    @ViewChild('treevalidate') treeSA?: TreeViewComponent;
    @ViewChild('treeoff') treeOffline?: TreeViewComponent;
    @ViewChild('gridRechte') public gridRechte?: GridComponent;
    @ViewChild('vinbkupUpload') public vinbkupUpload?: ElementRef<HTMLElement>;
    @ViewChild('vinbkInput') public vinbkInput?: any;
    @ViewChild('vinbkApply') public vinbkApply?: any;
    public languageForm = new UntypedFormControl('');
    public backUpFileTypes = ["vinbkup"];
    public blocked = false;
    public vinbkup: any;
    public blockedInfo: string = "";
    public backUpFileName: string = "";

    public offlineDaten: Object[] = [
        {
            id: 1,
            name: 'Mitarbeiter',
            hasChild: false,
            expanded: false,
            isChecked: true,
        },
        {
            id: 2,
            name: 'Mitarbeitergruppen',
            hasChild: false,
            expanded: false,
            isChecked: true,
        },
        {
            id: 3,
            name: 'Mandanten',
            hasChild: false,
            expanded: false,
            isChecked: true,
        },
        {
            id: 4,
            name: 'Termine / Pendenzen',
            hasChild: false,
            expanded: false,
            isChecked: true,
        },
        {
            id: 5,
            name: 'Dynamische Feldkonfigurationen',
            hasChild: false,
            expanded: false,
            isChecked: true,
        },
        {
            id: 6,
            name: 'Adresstypen',
            hasChild: false,
            expanded: false,
            isChecked: true,
        },
    ];

    public serviceAppDaten: Object[] = [
        {
            id: 1,
            name: 'Stammdaten',
            hasChild: true,
            expanded: false,
            isChecked: true,
        },
        {id: 2, pid: 1, name: 'Mandanteninformationen / Adresse'},
        {id: 3, pid: 1, name: 'Adresstypen'},
        {id: 4, pid: 1, name: 'Benutzerrechte'},
        {id: 5, pid: 1, name: 'Kostenstellen / Kostenstellenansätze'},
        {id: 6, pid: 1, name: 'Spesen'},
        {id: 7, pid: 1, name: 'Mitarbeiter / Mitarbeiteransätze'},
        {id: 8, name: 'Produkte', hasChild: false, isChecked: true},
        {id: 9, name: 'Objekte', hasChild: true, isChecked: true},
        {id: 10, pid: 9, name: 'Aufträge'},
        {id: 13, pid: 9, name: 'Adressen'},
        {id: 14, pid: 9, name: 'Dokumente'},
        {id: 15, pid: 9, name: 'Servicepositionen'},
        {id: 16, name: 'Checkliste', hasChild: false, isChecked: true},
        {id: 17, name: 'Dokumente', hasChild: false, isChecked: true},
    ];
    // maps the appropriate column to fields property
    public fieldOffline: Object = {
        dataSource: this.offlineDaten,
        id: 'id',
        parentID: 'pid',
        text: 'name',
        hasChildren: 'hasChild',
    };
    public fieldSA: Object = {
        dataSource: this.serviceAppDaten,
        id: 'id',
        parentID: 'pid',
        text: 'name',
        hasChildren: 'hasChild',
    };
    // set the CheckBox to the TreeView
    public showCheckBox: boolean = true;

    public importProgress: number = 0;
    public hideLoading: boolean = true;
    public webUserConfig: BenutzerModels.WebUserConfig;

    public sa_DefaultCostCenter?: TimeSheetModels.CostCenter;
    public sa_DefualtUserCostCenter?: TimeSheetModels.CostCenter;
    public anwender: BenutzerModels.Anwender;

    /* Benutzerrechte */
    public dbBenutzerGruppen: BenutzerModels.BenutzerGruppe[] = [];
    public userHasGroups: boolean = false;
    public dataSourceBenutzerRechte: BenutzerModels.BenutzerRechtListElement[] =
        [];
    public sortOptions: object;
    //private dbDokumentZuordnungen?: ServiceAppModels.SA_DocumentAssignment[];
    public downloadedDocuments: number = 0;
    public totalDocuments: number = 0;
    /* Kalendereinstellungen */

    public groupOptions?: Object = undefined;
    startSites: StartSite[] = [
        {value: 0, viewValue: ''}
    ];
    menuItems: any[] = [];
    public device: Device;
    private dbBenutzerRechte: BenutzerModels.BenutzerRecht[] = [];
    private dbRechteGruppenReihenfolge: BenutzerModels.RechtGruppeReihenfolge[] =
        [];

    constructor(
        private svcMainData: MainDataService,
        public localStorageService: LocalStorageService,
        public svcSwissSettings: SwissSettingsService,
        private svcObjekte: ObjektDataService,
        private translate: TranslateService,
        public userAuthService: UserAuthenticationService,
        private mesageBoxService: MessageBoxService,
        private router: Router, private helperService: HelperService, private deviceDetectionService: DeviceDetectionService
    ) {

        super(localStorageService, userAuthService, svcSwissSettings);
        this.device = this.deviceDetectionService.getDevice();
        this.webUserConfig = this.svcSwissSettings.getWebConfig();
        this.anwender = this.userAuthService.getCurrentAuthenticatedUser()!;
        this.sortOptions = {
            columns: [
                {field: 'OrderID', direction: 'Ascending'},
                {field: 'ID', direction: 'Ascending'},
            ],
        };
        this.setStartPageOptions();
    }

    // #region Backup Functions
    get getBackupFilePath() {
        return this.backUpFileName;
    }

    ngOnInit(): void {
        this.loadAppUserConfig();
        this.loadAppGroupRightsOrder();
        this.loadAppUserGroups();
        this.loadAppUserRights();
        this.setLanguage();

        this.languageForm.valueChanges.subscribe({
            next: (res) => {
                this.translate.use(res);
                this.localStorageService.add('language', res, 'SwissTimeEntry', false, true);
            },
        });
    }

    setLanguage() {
        this.localStorageService.get('language', 'SwissTimeEntry', true).then((res) => {
            console.log(res);
            if (!res) {
                this.languageForm.setValue(res);
            }
            this.languageForm.setValue(res);
        });
    }

    groupTemplateFn(args: any) {
        if (
            args != null &&
            args.field === 'GroupOrder' &&
            this.dbRechteGruppenReihenfolge
        ) {
            //console.log("groupTemplateFn", this.dbRechteGruppenReihenfolge.filter(rg => rg.groupOrder === args.key)[0]);
            return (
                args.headerText +
                ': ' +
                this.dbRechteGruppenReihenfolge.filter(
                    (rg) => rg.groupOrder === args.key
                )[0].rightsGrpText
            );
        } else {
            return args.headerText + ': ' + args.key;
        }
    }

    loadAppGroupRightsOrder() {
        this.userAuthService.getRightsGroupsOrder().then((value) => {
            if (value) {
                this.dbRechteGruppenReihenfolge = value;
                console.log(
                    'dbRechteGruppenReihenfolge',
                    this.dbRechteGruppenReihenfolge
                );
            }
        });
    }

    loadAppUserGroups() {
        this.userAuthService.getUserGroups().then((value) => {
            if (value) {
                this.dbBenutzerGruppen = value;
                this.userHasGroups = this.dbBenutzerGruppen.length > 0;
            }
        });
    }

    public speedMenuClicked(args: SpeedDialItemEventArgs): void {
        switch (args.item.id) {
            case (args.item.id = 'dashboard'):
                this.router.navigateByUrl('/dashboard-mobile');
                break;
            case (args.item.id = 'logout'):
                this.userAuthService.logoutUser('/login');
                break;

            default:
                return;
        }
    }

    public speedMenuCreated(): void {
        this.menuItems = [];
        this.menuItems.push({text: 'Dashboard', id: 'dashboard'});
        this.menuItems.push({text: 'Abmelden', id: 'logout'});
    }

    loadAppUserRights() {
        this.groupOptions = {columns: ['GroupOrder']};
        this.userAuthService.getUserRights().then((value) => {
            if (value) {
                this.dbBenutzerRechte = value;
                this.dataSourceBenutzerRechte = [];

                this.dbBenutzerRechte.forEach((br) => {
                    this.dataSourceBenutzerRechte.push({
                        ID: br.rightsID,
                        HatRecht: br.value,
                        HatGruppenRecht: br.groupValue,
                        HatEffektivRecht: br.effectiveValue,
                        Gruppe: br.rightsGrpText,
                        Rechtbeschreibung: br.rightsText,
                        Reihenfolge: br.textOrder,
                        OrderID: br.orderID,
                        GroupOrder: br.groupOrder,
                    });
                });
                this.gridRechte!.refresh();
            }
        });
    }

    setDebugMode(enabled: boolean) {
        this.webUserConfig.debugMode = enabled;
        // Einstellung wird sofort gespeichert
        this.localStorageService.add(
            'webuserconfig',
            this.webUserConfig,
            this.storageWebConfig,
            false,
            true
        );
        // Mit dem folgenden Befehl weiss der SwissSettingsService, dass die Einstellungen neu aus der DB geladen werden müssen
        this.svcSwissSettings.reloadWebUserConfig();
    }

    dropdownStartPageChange(event: MatSelectChange) {
        this.swissAppUserConfig!.startPage = event.value;
        this.svcSwissSettings.setStartPage(event.value);
    }

    onGridStartChange(value?: any) {
        if (value && value.target && value.target.value) {
            // Wert wird nur gespeichert, wenn dieser 5-stellig ist
            let wert = value.target.value;
            if (wert.length === 5) {
                this.timeGridStart = wert;
                this.svcSwissSettings.setTimeGrid(wert, this.timeGridEnd);
            }
            console.log('Grid Start', value.target.value);
        }
    }

    onGridEndChange(value?: any) {
        if (value && value.target && value.target.value) {
            // Wert wird nur gespeichert, wenn dieser 5-stellig ist
            let wert = value.target.value;
            if (wert.length === 5) {
                this.timeGridEnd = wert;
                this.svcSwissSettings.setTimeGrid(this.timeGridStart, wert);
            }
            console.log('Grid End', value.target.value);
        }
    }

    onWorkDayStartChange(value?: any) {
        if (value && value.target && value.target.value) {
            // Wert wird nur gespeichert, wenn dieser 5-stellig ist
            let wert = value.target.value;
            if (wert.length === 5) {
                this.timeWorkDayStart = wert;
                this.svcSwissSettings.setTimeGridWorkDay(wert, this.timeWorkDayEnd);
            }
            console.log('Grid WorkDay Start', value.target.value);
        }
    }

    onWorkDayEndChange(value?: any) {
        if (value && value.target && value.target.value) {
            // Wert wird nur gespeichert, wenn dieser 5-stellig ist
            let wert = value.target.value;
            if (wert.length === 5) {
                this.timeWorkDayEnd = wert;
                this.svcSwissSettings.setTimeGridWorkDay(this.timeWorkDayStart, wert);
            }
            console.log('Grid WorkDay End', value.target.value);
        }
    }

    async webEditionImport() {
        if (this.treeOffline) {
            // Mitarbeiter
            if (this.treeOffline.checkedNodes.findIndex((x) => x == '1') >= 0) {
                this.svcMainData.getMitarbeiter().subscribe({
                    next: (res) => {
                        if (this.webUserConfig.debugMode) console.log('Mitarbeiter', res);
                        this.localStorageService.add(
                            'mitarbeiter',
                            res,
                            this.storageWebMain
                        );
                    },
                    error: (error) =>
                        console.error(
                            'Mitarbeiter konnten nicht heruntergeladen werden. ',
                            error
                        ),
                });
            }

            // Mitarbeitergruppen
            if (this.treeOffline.checkedNodes.findIndex((x) => x == '2') >= 0) {
                // Gruppennamen
                this.svcMainData.getMitarbeiterGruppen().subscribe({
                    next: (res) => {
                        if (this.webUserConfig.debugMode)
                            console.log('Mitarbeitergruppen', res);
                        this.localStorageService.add(
                            'mitarbeitergruppen',
                            res,
                            this.storageWebMain
                        );
                    },
                    error: (error) =>
                        console.error(
                            'Gruppennamen konnten nicht heruntergeladen werden. ',
                            error
                        ),
                });

                // Gruppenzuordnungen
                this.svcMainData.getMitarbeiterGruppenZuord().subscribe({
                    next: (res) => {
                        if (this.webUserConfig.debugMode)
                            console.log('MitarbeiterGruppenZuord', res);
                        this.localStorageService.add(
                            'mitarbeitergruppenzuord',
                            res,
                            this.storageWebMain
                        );
                    },
                    error: (error) =>
                        console.error(
                            'Gruppenzuordnungen konnten nicht heruntergeladen werden. ',
                            error
                        ),
                });
            }

            // Mandanten
            if (this.treeOffline.checkedNodes.findIndex((x) => x == '3') >= 0) {
                await this.userAuthService.getSwissAppMandanten();
            }

            // Termine / Pendenzen
            if (this.treeOffline.checkedNodes.findIndex((x) => x == '4') >= 0) {
                this.svcMainData.getUserTermine().subscribe({
                    next: (res) => {
                        if (this.webUserConfig.debugMode) console.log('Termine', res);
                        this.localStorageService.add('termine', res, this.storageWebMain);
                    },
                    error: (error) =>
                        console.error(
                            'Termine/Pendenzen konnten nicht heruntergeladen werden. ',
                            error
                        ),
                });
            }

            // Feldkonfigurationen (Objekte für Offlinebetrieb)
            if (this.treeOffline.checkedNodes.findIndex((x) => x == '5') >= 0) {
                this.svcObjekte.getAllFormFields().subscribe({
                    next: (res: any) => {
                        if (this.webUserConfig.debugMode)
                            console.log('Feldkonfigurationen', res);
                        this.localStorageService.add(
                            'feldKonfigurationen',
                            res,
                            this.storageWebMain
                        );
                    },
                    error: (error: any) =>
                        console.error(
                            'Feldkonfigurationen konnten nicht heruntergeladen werden. ',
                            error
                        ),
                });
            }

            // Adress-Typen
            if (this.treeOffline.checkedNodes.findIndex((x) => x == '6') >= 0) {
                this.svcObjekte.getAddressTypen().subscribe({
                    next: (res: any) => {
                        if (this.webUserConfig.debugMode) console.log('AdressTypen', res);
                        this.localStorageService.add(
                            'adressTypen',
                            res,
                            this.storageWebMain
                        );
                    },
                    error: (error: any) =>
                        console.error(
                            'Adress-Typen konnten nicht heruntergeladen werden. ',
                            error
                        ),
                });
            }
        }
    }

    delay(ms: number) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }

    onChange(event: any) {
        var files = event.target?.files;

        if (files[0]) {
            if (this.acceptableFile(files[0], this.backUpFileTypes) && files.length == 1) {
                if (this.vinbkInput?.nativeElement) {
                    this.vinbkInput.nativeElement.files = files;
                    this.backUpFileName = files[0].name;
                    this.allowBKImport();
                }
            } else {
                this.disallowBKImport();
            }
        }
    }

    onDrop(event: DragEvent) {
        var file = event.dataTransfer?.items[0];

        if (file) {
            if (!this.acceptableFile(file, ["", ...this.backUpFileTypes])) {
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();
                if (this.vinbkInput?.nativeElement) this.vinbkInput.nativeElement.value = ""
                return;
            }
        }
    }

    onDragOver(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        var file = event.dataTransfer?.items[0];
        if (file) {
            if (this.acceptableFile(file, ["", ...this.backUpFileTypes])) {
                this.allowBKImport();
                return;
            }
            this.disallowBKImport();
        }
    }

    acceptableFile(file: File | DataTransferItem, acceptedType: any[]): boolean {
        let type: string;
        if (file instanceof File) {
            const split = (file as any).name.split(".")
            type = split[split.length - 1]
        } else {
            type = file.type
        }
        for (let i = 0; i < acceptedType.length; i++) {
            if (type == acceptedType[i]) {
                return true
            }
        }
        return false;
    }

    allowBKImport() {
        this.vinbkupUpload?.nativeElement.classList.add("acceptedFile");
        this.vinbkupUpload?.nativeElement.classList.remove("badFile");
        this.vinbkApply.nativeElement.classList.add("acceptedFile");
        this.vinbkApply.nativeElement.classList.remove("badFile");
    }

    disallowBKImport() {
        this.vinbkInput.nativeElement.value = '';
        this.vinbkupUpload?.nativeElement.classList.add("badFile");
        this.vinbkupUpload?.nativeElement.classList.remove("acceptedFile");
        this.vinbkApply?.nativeElement.classList.add("badFile");
        this.vinbkApply?.nativeElement.classList.remove("acceptedFile");
    }

    downloadBackup() {
        this.localStorageService.getAllData().then(obj => {
            var json_string = this.helperService.encryptUsingAES256(JSON.stringify(obj));
            var dataStr = "data:text/vinbkup;charset=utf-8," + encodeURIComponent(json_string);
            var dlAnchorElem = document.getElementById('downloadAnchorElem');
            if (dlAnchorElem) {
                dlAnchorElem.setAttribute("href", dataStr);
                dlAnchorElem.setAttribute("download", "bkup.vinbkup");
                dlAnchorElem.click();
            }
        });
    }

    loadBackup() {
        let fl: any = this.vinbkInput?.nativeElement?.files;
        if (fl && fl.length == 1) {
            this.mesageBoxService.askYesNoQuestion(
                "MAIN_APP_DIALOG.APPLY_BACKUP.msg",
                "MAIN_APP_DIALOG.APPLY_BACKUP.title"
            ).then(res => {
                if (!res) {
                    return;
                }
                let fr = new FileReader();
                var obj;
                fr.addEventListener("load", () => {
                    var s = this.helperService.decryptUsingAES256(fr.result as string);
                    obj = JSON.parse(JSON.parse(s));
                    this.applyBackup(obj);
                })
                fr.readAsText(fl[0], "utf8");
            });
        } else {
            this.vinbkInput.nativeElement.click();
        }
    }

    async applyBackup(obj: any) {
        this.localStorageService.lockDb();
        this.blocked = true;

        this.blockedInfo = "Cleaning Database";
        (window as any).resetIDB().then(() => {
            this.blockedInfo = "Applying Backup";

            this.restoreObjects(obj).finally(() => {
                this.localStorageService.unlockDB();
                this.blocked = false;
                window.location.reload();
            });

        }).catch((err: Error) => {
            console.log(err.message)
        });
    }

    restoreObjects(obj: any): Promise<any> {
        return new Promise((resolve, reject) => {
            var p: any[] = [];
            let names: any = Object.getOwnPropertyNames(obj);
            for (let i = 0; i < names.length; i++) {
                let keys: any = Object.getOwnPropertyNames(obj[names[i]]);
                for (let j = 0; j < keys.length; j++) {
                    p.push(this.localStorageService.add(keys[j], obj[names[i]][keys[j]], names[i], true))
                }
            }
            Promise.all(p).then((vals) => {
                resolve(vals)
            }).catch(() => reject());
        })
    }

    // #endregion

}
